import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import './LookingFor.css';
import factsheet from '../../../images/fund-factsheet-2.svg';
import dividend from '../../../images/nav-and-idcw.svg';
import etf from '../../../images/partner-corner.svg';
import account from '../../../images/account.png';
import investor from '../../../images/customer-service-2.svg';
import ionline from '../../../images/ionline.png';
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import Slider from 'react-slick';
import { useNavigate, useLocation } from "react-router-dom";
function LookingFor() {
    let navigate = useNavigate();
    const BlogSlider = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <BsArrowRight />,
        prevArrow: <BsArrowLeft />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const handleChange = (e) => {
        e.preventDefault();
        let path = '/Reach-Us/Get-In-Touch';
        let widthWindow = window.matchMedia("(max-width: 500px)")
        navigate(path, { state: { plan: "reachus" } });
        if (widthWindow.matches) {
            window.scrollTo({
                top: 1100,
                behavior: 'smooth',
            });
        }
        else{
            window.scrollTo({
                top: 1200,
                behavior: 'smooth',
            });
        }
        
    }
    return (
        <>
            <section className='looking-for-sc'>
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className='section-header'>
                                <h2>How Can We Help You</h2>
                            </div>
                            <div className="looking-slider our-funds-slider smart-slider">
                                    <Slider {...BlogSlider} className='slik-looking'>
                                        {/* <div className='looking-for-inner'>
                                        <a href="downloads/Factsheet">
                                            <img src={factsheet} className='img-fluid zoomlogo' alt='factsheet' />
                                            <h4>Fund Factsheets</h4>
                                          <span>View More</span></a>
                                        </div> */}
                                        <div className="looking-for-inner card-link" style={{backgroundColor : "white", zIndex : "0"}}>
                                            <Link
                                            to="/downloads/Factsheet"
                                            className="card-overlay-link"
                                            aria-labelledby="fund-factsheet-title"
                                            />
                                            {/* <a href="downloads/Factsheet" 
                                            className="card-overlay-link"
                                            aria-labelledby="factsheet-title">
                                            </a> */}

                                            <img src={factsheet} className="img-fluid zoomlogo" alt="" />
                                            <h3 id="fund-factsheet-title" className='heading-small'>Fund Factsheets</h3>
                                            <span>View More</span>
                                        </div>
                                        {/* <div className='looking-for-inner CursorPointer'>
                                        <a onClick={handleChange} href=''>
                                            <img src={investor} className='img-fluid zoomlogo' alt='customer-services-icon' />
                                            <h4>Customer Service</h4>
                                            <span>View More</span></a>
                                        </div> */}
                                        {/* <div className="looking-for-inner card-link" onClick={handleChange} tabIndex={0} 
                                         role='link'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleChange();
                                            }
                                        }}
                                        >
                                            <img src={investor} className='img-fluid zoomlogo' alt='customer-services-icon' />
                                            <h4>Customer Service</h4>
                                            <span>View More</span>
                                        </div> */}
                                        <div className='looking-for-inner card-link'>
                                        <Link
                                            to="/Reach-Us/Get-In-Touch"
                                            className="card-overlay-link"
                                            aria-labelledby="customer-service-title"
                                        ></Link>
                                        <img src={investor} className='img-fluid zoomlogo' alt='' />
                                        <h4 id="customer-service-title">Customer Service</h4>
                                        <span>View More</span>
                                        </div>
                                        {/* <div className='looking-for-inner'>
                                             <Link
                                            to="PartnersCorner"
                                            className="card-overlay-link"
                                            aria-labelledby="partner-corner"
                                            />
                                        <a href="PartnersCorner">
                                            <img src={etf} className='img-fluid zoomlogo' alt='etf' />
                                            <h4>Partner Corner</h4>
                                            <span>View More</span></a>
                                        </div> */}
                                        <div className='looking-for-inner card-link'>
                                            
                                            <Link
                                                to="/PartnersCorner"
                                                className="card-overlay-link"
                                                aria-labelledby="partner-corner-title"
                                            ></Link>

                                            {/* Card content */}
                                            <img src={etf} className='img-fluid zoomlogo' alt='' />
                                            <h4 id="partner-corner-title">Partner Corner</h4>
                                            <span>View More</span>
                                        </div>
                                        <div className='looking-for-inner card-link'>
                                            <Link
                                                to="NAVs-and-IDCW//LatestNav"
                                                className='card-overlay-link'
                                                aria-labelledby="nav-idcw-title"
                                            />
                                            <img src={dividend} className='img-fluid zoomlogo' alt='' />
                                            <h4 id="nav-idcw-title">NAV and IDCW</h4>
                                            <span>View More</span>
                                            </div>
                                        {/* <div className='looking-for-inner'>
                                        <a href='https://investor.jmfinancialmf.com/jmfinvestor/' target='blank'>
                                            <img src={ionline} className='img-fluid zoomlogo' alt='ionline' />
                                            <h4>Investor Corner</h4>
                                             View More</a>
                                        </div> */}

                                    </Slider>
                            </div>
                            {/* </div> */}
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* <section className="blog-sc global-blog-sc">
                <Container>
                    <Row>
                        <Col sm={12}>
                            <div className='section-header'>
                                <h2>What Are You Looking <br></br>For?</h2>
                            </div>
                            <div className="blog-slider our-funds-slider smart-slider">
                                <Slider {...BlogSlider}>
                                   
                                        <div className='looking-for-inner'>
                                            <img src={factsheet} className='img-fluid zoomlogo' alt='factsheet' />
                                            <h4>Fund Factsheets</h4>
                                            <a>View More</a>
                                        </div>
                             
                                    <div className='zoom'>
                                        <div className='looking-for-inner'>
                                            <img src={investor} className='img-fluid zoomlogo' alt='investor' />
                                            <h4>Customer Services</h4>
                                            <a>View More</a>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}
        </>
    );
}

export default LookingFor;